export const GET_TRACKING_IMAGES = "GET_TRACKING_IMAGES"
export const GET_TRACKING_IMAGES_SUCCESS = "GET_TRACKING_IMAGES_SUCCESS"
export const GET_TRACKING_IMAGES_ERROR = "GET_TRACKING_IMAGES_ERROR"

export const GET_TRACKING_IMAGE = "GET_TRACKING_IMAGE"
export const GET_TRACKING_IMAGE_SUCCESS = "GET_TRACKING_IMAGE_SUCCESS"
export const GET_TRACKING_IMAGE_ERROR = "GET_TRACKING_IMAGE_ERROR"

export const ADD_TRACKING_IMAGE = "ADD_TRACKING_IMAGE"
export const ADD_TRACKING_IMAGE_SUCCESS = "ADD_TRACKING_IMAGE_SUCCESS"
export const ADD_TRACKING_IMAGE_ERROR = "ADD_TRACKING_IMAGE_ERROR"

export const EDIT_TRACKING_IMAGE = "EDIT_TRACKING_IMAGE"
export const EDIT_TRACKING_IMAGE_SUCCESS = "EDIT_TRACKING_IMAGE_SUCCESS"
export const EDIT_TRACKING_IMAGE_ERROR = "EDIT_TRACKING_IMAGE_ERROR"

export const DELETE_TRACKING_IMAGE = "DELETE_TRACKING_IMAGE"
export const DELETE_TRACKING_IMAGE_SUCCESS = "DELETE_TRACKING_IMAGE_SUCCESS"
export const DELETE_TRACKING_IMAGE_ERROR = "DELETE_TRACKING_IMAGE_ERROR"

export const RESET_TRACKING_IMAGE_FLAG = "RESET_TRACKING_IMAGE_FLAG"
